import { createAsyncThunk } from '@reduxjs/toolkit';
import { activeSnack } from '../store/common';
import { get } from './http';

export const getSettings = createAsyncThunk('enquirys/list', async ({ dispatch }) => {
  try {
    const URL = `/settings/all`;

    const response = await get(URL);
    if (response) {
      // return {
      //   list: response?.settings,
      //   total: response?.total,
      // };
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
